import { Component, OnInit, ViewChild, OnChanges, Input, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { Chart } from 'chart.js'


export interface DataSetModel {
	label: any,
	backgroundColor?: string | string[],
	data: any,
	borderColor?: string | string[],
	fill?: boolean,
	showLine?: boolean,
	borderWidth?: number | number[]
}

export interface PieChartModel {
	labels: any[],
	datasets: DataSetModel[]
}
export interface PieOptionsModel {
	title?: {
		display: boolean,
		text: string,
		position?: string,
		fontColor?: string,
		fontSize?: number
	},
	maintainAspectRatio?: boolean,
	animation?: {
		duration?: number // general animation time
		onProgress?: Function,
		onComplete?: Function
	},
	hover?: {
		animationDuration?: number // duration of animations when hovering an item
	},
	responsiveAnimationDuration?: number,
	showTooltips?: boolean,
	disablePointerEvents?: boolean,
	tooltips?: {
		callbacks?: {
			label?: Function
		},
		enabled?: boolean;
	},
	responsive?: boolean,
	legend?: {
		display?: boolean,
		position?: string,
		labels?: {
			fontColor?: string,
			fontSize?: number
		}
	},
	cutoutPercentage?: number,
	layout?: {
		padding: {
			left: number,
			right: number,
			top: number,
			bottom: number
		}
	}
}
@Component({
	selector: 'app-pie-chart',
	templateUrl: './pie-chart.component.html',
	styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit {

	@Input() chartData: PieChartModel;
	@Input() chartOptions: PieOptionsModel;
	@ViewChild('pieChart') pieChart: ElementRef;
	constructor(
		private renderer2: Renderer2,
		private cdref: ChangeDetectorRef
	) { }

	ngOnInit(): void {
	}


	ngOnChanges(changes) {
		this.cdref.detectChanges();
		const pieCanvas: any = this.pieChart.nativeElement.getContext('2d');
		if (changes.chartData && this.pieChart && (changes.chartData.currentValue || changes.chartOptions && changes.chartOptions.currentValue)) {
			let pieChart = new Chart(pieCanvas, {
				type: 'pie',
				data: this.chartData,
				options: this.chartOptions
			});
			// To disable pointer Events when scroll
			if (this.chartOptions.hasOwnProperty('disablePointerEvents')) {
				if (this.chartOptions.disablePointerEvents) {
					this.renderer2.setStyle(this.pieChart.nativeElement, 'pointer-events', 'none');
				}
			}

		}
	}

}
